import { customAlphabet, nanoid } from 'nanoid';

/** Идентификатор объекта доски. */
export const objectId = (): string => nanoid(12);

/** Идентификаторы сущностей в БД. */
export const entityId = (): string => nanoid(16);

/** Человекочитаемые слаги для публичных досок и ссылок-приглашений. */
const slugAlphabet = customAlphabet('23456789abcdefghjkmnpqrstuvwxyz', 10);
export const shortSlug = (): string => slugAlphabet();

/** Транслитерация + слаг из названия доски. */
const TRANSLIT: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l',
  м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh',
  щ: 'sch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

export function slugify(input: string, maxLength = 48): string {
  const s = input
    .toLowerCase()
    .split('')
    .map((ch) => TRANSLIT[ch] ?? ch)
    .join('')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, maxLength)
    .replace(/-+$/g, '');
  return s || 'board';
}
